import React, { useState } from "react";

const HolidayForm = ({
  loading,
  closeModal,
  onSubmit,
  initialValues,
  errors = {}, 
}) => {
  const [formData, setFormData] = useState(initialValues);

  const handleChange = (e) => {
    const { name, value } = e.target;
  
    if (name === "occasion") {
      const allowedPattern = /^[A-Za-z. ]*$/; // allows letters, space and .
      if (value === "" || allowedPattern.test(value)) {
        setFormData((prev) => ({ ...prev, [name]: value }));
      }
    } else {
      setFormData((prev) => ({ ...prev, [name]: value }));
    }
  };
  
  const handleSubmit = (e) => {
    e.preventDefault();


    // const allowedDays = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
    // const isValidDay = allowedDays.includes(formData.day);

    // if (!isValidDay) {
    //   alert("Please enter a valid day from Monday to Saturday");
    //   return;
    // }

    const submissionData = new FormData(); // Use FormData for file upload
    // submissionData.append("day", formData.day);
    submissionData.append("date", formData.date);
    submissionData.append("occasion", formData.occasion);

    onSubmit(submissionData); // Pass the FormData to the parent onSubmit handler
  };

  return (
    <form onSubmit={handleSubmit} className="space-y-4">
      {/* Name Field */}
        {/* <div>
            <label htmlFor="day" className="block text-sm font-medium dark:text-white text-gray-700">
            Day <span className="text-red-500 ml-1">*</span>
            </label>
            <input
            type="text"
            id="day"
            name="day"
            value={formData.day}
            onChange={handleChange}
            className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
                errors.day ? "border-red-500" : "border-gray-300"
            }`}
            required
            />
            {errors.day && <p className="text-red-500 text-sm mt-1">{errors.day}</p>}
        </div> */}

        {/* {!initialValues.id ? */}
            <div>
                <label htmlFor="date" className="block text-sm font-medium dark:text-white text-gray-700">
                Date <span className="text-red-500 ml-1">*</span>
                </label>
                <input
                type="date"
                id="date"
                name="date"
                value={formData.date}
                onChange={handleChange}
                className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
                    errors.day ? "border-red-500" : "border-gray-300"
                }`}
                required
                />
                {errors.date && <p className="text-red-500 text-sm mt-1">{errors.date}</p>}
            </div>
        {/* : ("")} */}
        

        {/* Description Field */}
        <div>
            <label htmlFor="occasion" className="block text-sm font-medium dark:text-white text-gray-700">
            Occasion <span className="text-red-500 ml-1">*</span>
            </label>
            <input
            type="text"
            id="occasion"
            name="occasion"
            value={formData.occasion}
            onChange={handleChange}
            className={`mt-1 dark:bg-black dark:text-white dark:border-gray-700 block w-full border rounded-md p-2 ${
                errors.occasion ? "border-red-500" : "border-gray-300"
            }`}
            maxLength={25}
            required
            />
            {errors.occasion && <p className="text-red-500 text-sm mt-1">{errors.occasion}</p>}
            <small><p className="text-sm text-gray-500 mt-1">
              {formData.occasion.length}/25 characters
            </p>
            </small>
        </div>


        {/* Form Actions */}
        <div className="flex justify-end items-center gap-2">
            <button
            type="button"
            onClick={closeModal}
            className="px-6 py-2 font-medium text-black hover:bg-gray-200 dark:hover:bg-gray-900 dark:bg-black dark:text-white dark:focus:outline-none border border-gray-300 rounded-md"
            >
            Cancel
            </button>
            <button
            type="submit"
            className="flex items-center gap-2 px-8 py-2 font-medium bg-blue-600 text-white rounded-md hover:bg-blue-700"
            >
            {initialValues.id ? "Update" : "Add"}
            {loading && (
                <svg
                className="animate-spin h-5 w-5 ml-2 text-white"
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                >
                <circle
                    className="opacity-25"
                    cx="12"
                    cy="12"
                    r="10"
                    stroke="currentColor"
                    strokeWidth="4"
                ></circle>
                <path
                    className="opacity-75"
                    fill="currentColor"
                    d="M4 12a8 8 0 018-8v4a4 4 0 00-4 4H4z"
                ></path>
                </svg>
            )}
            </button>
        </div>
    </form>
  );
};

export default HolidayForm;
